import type { HeadlinePriceType } from '@phx/data-sources/medication-marketplace';

export const isPharmacySpecificOffer = (
    offer?:
        | { headlinePriceType?: HeadlinePriceType | string | null }
        | undefined
): boolean =>
    offer?.headlinePriceType === 'PharmacyIncentive' ||
    offer?.headlinePriceType === 'DiscountedCashPrice';
